import { useState } from "react";
import { useLocation } from "react-router-dom";

/** Reads a typed key from React Router's `location.state` once at mount and
 *  holds it stable for the lifetime of the component.
 *
 *  Snapshot-on-mount is intentional: native anchor clicks (e.g. `#source-1`
 *  citation links) push a new history entry with null state, which would
 *  otherwise clear data passed via router state on the next re-render.
 *  Capturing the value in a `useState` initialiser isolates it from
 *  subsequent location changes. */
export function useLocationState<T>(key: string): T | undefined {
  const location = useLocation();
  const [value] = useState<T | undefined>(
    () => (location.state as Record<string, unknown> | null)?.[key] as T | undefined
  );
  return value;
}
